import { Controller } from "@hotwired/stimulus"
import { track as mixpanelTrack } from "../lib/mixpanel"

// Phase 2.1 Tier 3 — drives the delete-confirmation modal on the
// transfer audit trail page. Kept as its own controller so the page
// doesn't need to load the full budget_controller (which requires the
// tree targets on the show view).
export default class extends Controller {
  static targets = ["modal", "description"]

  show(event) {
    const row = event.currentTarget.closest("[data-transfer-id]")
    if (!row) return
    this._pendingId = row.dataset.transferId
    this._pendingUrl = row.dataset.transferUrl
    this._pendingSummary = row.dataset.transferSummary || ""
    this.descriptionTarget.textContent = this._pendingSummary
    this.modalTarget.classList.remove("hidden")
  }

  hide() { this.modalTarget.classList.add("hidden") }
  stopPropagation(event) { event.stopPropagation() }

  async confirm() {
    if (!this._pendingUrl) return
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    const resp = await fetch(this._pendingUrl, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": csrf,
        "Accept": "application/json"
      }
    })

    if (!resp.ok) {
      this.modalTarget.classList.add("hidden")
      this._toast("Failed to delete transfer", "error")
      return
    }

    try { mixpanelTrack("Budget Transfer Deleted", { budget_transfer_id: Number(this._pendingId) }) } catch {}
    sessionStorage.setItem("budget_flash", JSON.stringify({ message: "Transfer deleted", type: "success" }))
    window.location.reload()
  }

  _toast(message, type = "success") {
    const cssType = (type === "error" || type === "alert") ? "alert" : "notice"
    const el = document.createElement("div")
    el.className = `flash-toast-${cssType}`
    el.setAttribute("data-controller", "flash")
    el.setAttribute("data-flash-dismiss-after-value", "5000")
    el.setAttribute("role", "alert")
    const msgP = document.createElement("p")
    msgP.className = "flex-1 text-sm"
    msgP.textContent = message
    el.appendChild(msgP)
    document.body.prepend(el)
  }
}
